import queryString from "query-string";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import { confirmEmail, resendConfirmationEmail } from "../api/auth";
import Loader from "../components/loader";
import { Meta } from "../components/meta";
import { LoginPageWrapper } from "../components/mui-login-page-wrapper";
import useWindow from "../hooks/useWindow";
import { Footer } from "./reset-password";

const ConfirmationEmailPage: React.FC<any> = () => {
  // const [passwordOne, setPasswordOne] = useState('')
  // const [passwordTwo, setPasswordTwo] = useState('')
  const [pageError, setPageError] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [email, setEmail] = useState("");

  const _window = useWindow();
  const location = _window.location;

  const isResetPage = useMemo(() => {
    const q = queryString.parse(location.search);
    const { hash } = q;
    const queryIsValid = hash && typeof hash === "string";
    return !queryIsValid;
  }, [location.search]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setPageError([]);
    const isValid = validateInputs();
    if (isResetPage) {
      if (isValid) {
        const execute = async () => {
          const result = await resendConfirmationEmail({ email });
          const { error, message } = result;
          if (error !== 200) {
            setPageError((e) => [...e, `${message}`]);
          } else {
            setShowMessage(true);
          }
        };
        execute();
      }
    }
  };

  const validateInputs = useCallback(() => {
    let isValid = false;
    if (isResetPage) {
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        setPageError((e) => [
          ...e,
          "Your email does not seem to be a valid email.",
        ]);
      } else {
        isValid = true;
      }
    }

    return isValid;
  }, [email, isResetPage]);

  useEffect(() => {
    if (!isResetPage && !loading) {
      const q = queryString.parse(location.search);
      const { hash } = q;
      if (hash && typeof hash === "string") {
        setLoading(true);
        const execute = async () => {
          const result = await confirmEmail({
            hash,
          });
          const { error, message } = result;
          if (error !== 200) {
            setPageError((e) => [...e, `${message}`]);
          } else {
            setShowMessage(true);
          }
          // setLoading(false)
        };
        execute();
      }
    }
  }, [isResetPage, loading, location.search]);

  if (isResetPage) {
    return (
      <LoginPageWrapper
        title="Confirm email"
        error={pageError}
        onSubmit={handleSubmit}
      >
        <>
          <Meta title="Confirm your email for MetOceanAtlas" />
          {showMessage ? (
            <>
              <p>
                We have generated a new confirmation email. Please check your
                inbox.
              </p>
              <Footer />
            </>
          ) : (
            <>
              <p>
                Enter your account's email address, and we'll send you a new
                confirmation email.
              </p>
              <FormControl>
                <TextField
                  id="email"
                  type="email"
                  name="email"
                  label="Email address"
                  placeholder="Email address"
                  autoComplete="email"
                  autoFocus
                  required
                  fullWidth
                  variant="outlined"
                  onChange={(event: React.SyntheticEvent) => {
                    // @ts-ignore
                    setEmail(event.currentTarget.value);
                  }}
                  color={"primary"}
                />
              </FormControl>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={validateInputs}
                disabled={loading}
              >
                {loading ? <Loader small /> : "Send confirmation email"}
              </Button>
              <Footer />
            </>
          )}
        </>
      </LoginPageWrapper>
    );
  }

  return (
    <LoginPageWrapper
      title="Confirm email"
      error={pageError}
      onSubmit={handleSubmit}
    >
      <>
        <Meta title="Confirm your email for MetOceanAtlas" />
        {showMessage ? (
          <p>
            Your email has been confirmed. Please{" "}
            <Link
              to="/login"
              // variant="body2"
              // sx={{ alignSelf: 'center' }}
            >
              Sign in
            </Link>{" "}
            using your email.
          </p>
        ) : (
          <>
            <Loader center />
            <Footer />
          </>
        )}
      </>
    </LoginPageWrapper>
  );
};

export default ConfirmationEmailPage;

export const Head: any = () => <title>Confirmation</title>;
